import { FC, useMemo, useState } from 'react'
import { AutoComplete } from 'antd'
import { FormEntryField } from '../../../core/type'
import { watchDials } from '../model-mapper/item-static-data'

export type WatchDialAutoCompleteProps = FormEntryField<string> & {
  disabled?: boolean
}

export const WatchDialAutoComplete: FC<WatchDialAutoCompleteProps> = ({ value, onChange, disabled }) => {
  const [search, setSearch] = useState<string>('')

  const options = useMemo(() => {
    const term = search.toLowerCase()
    return watchDials
      .filter(dial => dial.toLowerCase().includes(term))
      .map(dial => ({ label: dial, value: dial }))
  }, [search])

  return (
    <AutoComplete<string>
      className='w-100'
      disabled={disabled}
      value={value ?? undefined}
      options={options}
      onSearch={setSearch}
      onChange={next => onChange?.(next || undefined)}
      allowClear
    />
  )
}
